import { useEffect, useRef } from "react";

import styles from "./Map.module.css";

export default function Map() {
  const mapElement = useRef(null);

  useEffect(() => {
    const { naver } = window;

    if (!!!mapElement.current || !!!naver) return;

    const location = new naver.maps.LatLng(35.1814, 126.9077);

    const mapOptions = {
      center: location,
      zoom: 17,
      zoomControl: true,
      scaleControl: false,
      logoControlOptions: {
        position: naver.maps.Position.TOP_RIGHT,
      },
    };
    const map = new naver.maps.Map(mapElement.current, mapOptions);

    const contentString = [
      `<div style="box-sizing:content-box; padding: 15px; text-align: center; font-size: 16px; color: white;">`,
      "hellowvaron",
      "</div>",
    ].join("");
    const marker = new naver.maps.Marker({ position: location, map: map });

    var infowindow = new naver.maps.InfoWindow({
      content: contentString,
      maxWidth: 140,
      backgroundColor: "#132145",
      borderColor: "#222222",
      borderWidth: 0,
      anchorSkew: true,
      anchorColor: "#364875",
    });

    naver.maps.Event.addListener(
      marker,
      "click",
      function (e) {
        if (infowindow.getMap()) {
          infowindow.close();
        } else {
          infowindow.open(map, marker);
        }
      },
      []
    );
  });
  return (
    <div className={styles.mapContainer}>
      <div ref={mapElement} className={styles.Map} />
    </div>
  );
}
